import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import Loading from './widgets/Loading'
import {
    MASTER_ACCOUNT_UPDATE_LOADED,
    MASTER_ACCOUNT_UPDATE,
    MASTER_ACCOUNT_UPDATE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.account,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: MASTER_ACCOUNT_UPDATE_LOADED, payload }),
    onSubmit: (key, publicKey, privateKey) => {
        const payload = agent.Accounts.updateMasterAccount(key, publicKey, privateKey);
        dispatch({ type: MASTER_ACCOUNT_UPDATE, payload })
    },
    onUnload: () =>
        dispatch({ type: MASTER_ACCOUNT_UPDATE_UNLOADED })
});

class MasterAccountUpdate extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            symbol: '',
            publicKey: '',
            privateKey: '',
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (publicKey, privateKey) => ev => {
            ev.preventDefault();
            this.props.onSubmit(this.props.match.params.key, publicKey, privateKey);
        }
    }
    componentWillMount() {
        this.props.onLoad(agent.Accounts.getMasterAccountByKey(this.props.match.params.key));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.account) {
            Object.assign(this.state, {
                name: nextProps.account.name,
                symbol: nextProps.account.symbol,
                publicKey: nextProps.account.external,
                privateKey: '',
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }
    render() {
        if (!this.props.account) {
            return (
                <Loading />
            )
        }
        const name = this.state.name;
        const symbol = this.state.symbol;
        const publicKey = this.state.publicKey;
        const privateKey = this.state.privateKey;

        return (
            <div class='pane'>
                <Link className="crumb" to="/masteraccounts">&laquo; back to master accounts</Link>
                <h1>Update master account</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(publicKey, privateKey)}>
                    <fieldset className="form">
                        <strong>Public key</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder="Public key"
                                value={publicKey}
                                onChange={this.updateState('publicKey')} />
                        </fieldset>

                        <strong>Replace Private Key</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder="Private Key"
                                value={privateKey}
                                onChange={this.updateState('privateKey')} />
                        </fieldset>
                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Update account
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MasterAccountUpdate);



// WEBPACK FOOTER //
// ./src/components/MasterAccountUpdate.js